import { useCallback, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { selectBasketExams } from 'store/basket/basketSlice';
import { selectCandidate, selectCandidateProductDetails } from 'store/candidate/candidateSlice';
import { useAppSelector } from 'store/hooks';

import { ROUTES } from '..';

export enum CustomerJourneyStep {
  CandidateDetails = 1,
  CandidateProductDetails = 2,
  TermsAndConditions = 3,
}

export const useCustomerJourneyStep = (step: CustomerJourneyStep) => {
  const navigate = useNavigate();
  const basketItems = useAppSelector(selectBasketExams);
  const candidateDetails = useAppSelector(selectCandidate);
  const candidateProductDetails = useAppSelector(selectCandidateProductDetails);

  useEffect(() => {
    if (basketItems.length === 0) {
      navigate(ROUTES.COUNTRY_SELECTOR);
    } else if (!candidateDetails && step > CustomerJourneyStep.CandidateDetails) {
      navigate(ROUTES.TEST_TAKER_DETAILS);
    } else if (!candidateProductDetails && step > CustomerJourneyStep.CandidateProductDetails) {
      navigate(ROUTES.CANDIDATE_PRODUCT_DETAILS);
    }
  }, [step, basketItems, candidateDetails, candidateProductDetails]);

  const goBack = useCallback(() => {
    const prevRoute = getPrevStepRoute(step);
    if (prevRoute) {
      navigate(prevRoute);
    }
  }, [step]);

  return {
    goBack,
  };
};

function getPrevStepRoute(step: CustomerJourneyStep) {
  switch (step) {
    case CustomerJourneyStep.CandidateProductDetails:
      return ROUTES.TEST_TAKER_DETAILS;
    case CustomerJourneyStep.TermsAndConditions:
      return ROUTES.CANDIDATE_PRODUCT_DETAILS;
    default:
      return '';
  }
}
